import type { ReactNode } from "react"

import { cn } from "@/lib/utils"

/**
 * OKS-706 — Responsive card grid for the {@link HomeTriageSection} shell.
 *
 * Breakpoints (UX Spec §5): 1-col mobile (320–639px), 2-col tablet
 * (640–1023px), 3-col desktop (≥1024px). The 3-up desktop cap keeps the
 * per-card TikTok embed legible without crowding (TRD KD4 / UX Q2).
 *
 * Purely presentational + data-shape-agnostic so the sibling triage
 * consumers (OKS-707/708) reuse it verbatim.
 */
interface HomeTriageCardGridProps {
  children: ReactNode
  className?: string
  "data-testid"?: string
}

export function HomeTriageCardGrid({
  children,
  className,
  "data-testid": dataTestid,
}: HomeTriageCardGridProps) {
  return (
    <div
      data-testid={dataTestid}
      className={cn(
        "grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3",
        className,
      )}
    >
      {children}
    </div>
  )
}
